<template>
  <svg
    width="76"
    height="91"
    viewBox="0 0 76 91"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M45.5 0L75.8333 30.3333V80.3833C75.8333 86.2468 71.0801 91 65.2167 91H10.6167C4.75324 91 0 86.2468 0 80.3833V10.6167C0 4.75324 4.75324 0 10.6167 0H45.5Z"
      fill="#F9F9F9"
    />
    <rect
      x="10.6167"
      y="12.8917"
      width="37.1583"
      height="2.275"
      fill="#B5B5B5"
    />
    <rect x="10.6167" y="20.475" width="50.05" height="2.275" fill="#B5B5B5" />
    <rect x="10.6167" y="28.0583" width="50.05" height="2.275" fill="#B5B5B5" />
    <rect
      x="10.6167"
      y="35.6417"
      width="37.1583"
      height="2.275"
      fill="#B5B5B5"
    />
    <rect x="10.6167" y="43.225" width="50.05" height="2.275" fill="#B5B5B5" />
    <rect x="11" y="51" width="37.1583" height="2.275" fill="#B5B5B5" />
    <rect x="11" y="58.5833" width="50.05" height="2.275" fill="#B5B5B5" />
    <rect x="11" y="66.1667" width="50.05" height="2.275" fill="#B5B5B5" />
    <rect x="11" y="73.75" width="37.1583" height="2.275" fill="#B5B5B5" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M75.8334 30.3333H56.6529C50.7895 30.3333 45.5 25.0439 45.5 19.1805V1.04904e-05L75.8334 30.3333Z"
      fill="#E4E4E4"
    />
  </svg>
</template>

<script>
export default {
  name: "TextFileIcon"
};
</script>
